"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initKeyboardEscapePlugin = initKeyboardEscapePlugin;

var _utils = require("../utils");

var _hsformatting = require("../constants/hsformatting");

var _usageTracking = require("../utils/usageTracking");

var _usageTracking2 = require("../constants/usageTracking");

var _dom = require("../utils/dom");

var _utils2 = require("./utils");

var ENTER_KEY = 13;
var CARRIAGE_RETURN_LIMIT = 3;
var TEXT_NODE = '#text'; // Escape out of a codeblock/pre tag when the user hits a carriage returns and
// makes [n=3] consecutive <br> tags. If this occurs within a codeblock, the block
// is split into {before} & {after} blocks, and a blank <p> tag is inserted and
// selected where appropriate (before, in the middle, or after the initial block).

function codeblockKeyboardEscape(editor, parentCodeblock, event) {
  var bookmark = editor.selection.getBookmark();
  var bookmarkNode = editor.dom.get(bookmark.id + "_start");

  if (bookmarkNode.nextSibling && bookmarkNode.nextSibling.nodeName === TEXT_NODE && bookmarkNode.nextSibling.nodeValue) {
    editor.selection.moveToBookmark(bookmark);
    return;
  } // Check for [n] previous carriage returns


  var curNode = bookmarkNode;
  var counter = 0;

  while (counter < CARRIAGE_RETURN_LIMIT && curNode.previousSibling && curNode.previousSibling.nodeName === 'BR') {
    curNode = curNode.previousSibling;
    counter++;
  }

  if (counter === CARRIAGE_RETURN_LIMIT) {
    var nextNode;

    while (curNode !== bookmarkNode) {
      nextNode = curNode.nextSibling;
      editor.dom.remove(curNode);
      curNode = nextNode;
    }

    var parentBlock = editor.dom.getParent(bookmarkNode, 'strong,em,span:not([data-mce-type="bookmark"])', parentCodeblock);

    if (parentBlock) {
      var placeholder = editor.dom.create('br');
      editor.dom.insertAfter(placeholder, parentBlock);
      curNode = placeholder;
    }

    var rng = editor.selection.getRng(); // Clear content after bookmark in current codeblock

    (0, _utils2.clearRngContent)(editor, rng, curNode, parentCodeblock.lastChild); // Add new <p> block

    var newBlock = editor.dom.create('p', {}, _dom.BOGUS_BR);
    editor.dom.insertAfter(newBlock, parentCodeblock);
    editor.selection.setCursorLocation(newBlock, newBlock.childNodes.length); // Cleanup bookmark if needed

    if (bookmarkNode.parentNode) {
      bookmarkNode.parentNode.removeChild(bookmarkNode);
    }

    event.preventDefault();
    (0, _usageTracking.trackInteraction)(editor, 'tinymceKeyboardEscape', _usageTracking2.ESCAPE_BLOCK_FORMAT, {
      format: 'codeblock'
    });
    return;
  }

  editor.selection.moveToBookmark(bookmark);
} // Escape out of a blockquote if the user hits a carriage return to make
// [n=3] consecutive <br> tags.


function blockquoteKeyboardEscape(editor, parentBlockquote, event) {
  var rng = editor.selection.getRng();
  var selectedEndNode = editor.dom.getParent(rng.endContainer, 'p,h1,h2,h3,h4,h5,h6', parentBlockquote); // Check for [n=3] previous carriage returns

  var curNode = selectedEndNode;
  var counter = 0;

  while (counter < CARRIAGE_RETURN_LIMIT && curNode) {
    if (!(0, _utils2.isLinebreakNode)(curNode)) break;
    counter++;

    if (counter < CARRIAGE_RETURN_LIMIT) {
      curNode = curNode.previousSibling;
    }
  } // Remove the extra carriage returns and un-blockquote the last line


  if (counter === CARRIAGE_RETURN_LIMIT) {
    var nextNode;

    while (curNode !== selectedEndNode) {
      nextNode = curNode.nextSibling;
      editor.dom.remove(curNode);
      curNode = nextNode;
    }

    editor.selection.select(selectedEndNode);
    editor.execCommand('hsblockquote');
    editor.selection.setCursorLocation(selectedEndNode);
    event.preventDefault();
    (0, _usageTracking.trackInteraction)(editor, 'tinymceKeyboardEscape', _usageTracking2.ESCAPE_BLOCK_FORMAT, {
      format: 'blockquote'
    });
  }
}

function initKeyboardEscapePlugin(editor) {
  var formats = (0, _utils.getHsformattingSettings)(editor.settings, _hsformatting.hsformattingConfig.KEYBOARD_ESCAPE_FORMATS) || [];
  if (!formats.length) return;
  var codeblockEscape = formats.includes('pre');
  var blockquoteEscape = formats.includes('blockquote');
  var selector = formats.join(',');

  if (codeblockEscape || blockquoteEscape) {
    editor.on('init', function () {
      editor.on('KeyDown', function (event) {
        if (event.keyCode !== ENTER_KEY || !editor.selection.isCollapsed()) {
          return;
        }

        var parentBlock = editor.dom.getParent(editor.selection.getNode(), selector, editor.getBody());
        if (!parentBlock) return;
        var bookmark = editor.selection.getBookmark();
        var bookmarkNode = editor.dom.get(bookmark.id + "_start"); // Bookmark node's next sibling should be a <br> if at the end of the block

        var atEndOfBlock = bookmarkNode.nextSibling && (0, _utils2.isNestedLastChild)(bookmarkNode.nextSibling, parentBlock);
        bookmarkNode.parentNode.removeChild(bookmarkNode);
        if (!atEndOfBlock) return;

        if (codeblockEscape && parentBlock.nodeName === 'PRE') {
          codeblockKeyboardEscape(editor, parentBlock, event);
        }

        if (blockquoteEscape && parentBlock.nodeName === 'BLOCKQUOTE') {
          blockquoteKeyboardEscape(editor, parentBlock, event);
        }
      });
    });
  }
}